import { TravelApiInterface } from "@syadem/kairos-citizen-js";
import { ActionResult } from "../../actionResult";
import { TravelRecord, TravelSnapshot } from "../../domain/travel";
import { fromApiTravel, toApiTravel } from "../../network/apis/travelMapper";
import { Service } from "../service";

interface Payload {
  healthRecordId: string;
  travel: TravelSnapshot;
}

export class CreateTravelService implements Service<Payload, TravelRecord> {
  constructor(private readonly travelApi: TravelApiInterface) {}

  async call({ healthRecordId, travel }: Payload): Promise<ActionResult<TravelRecord>> {
    const record = await this.travelApi.createTravel(healthRecordId, { travel: toApiTravel(travel) });

    return {
      type: "success",
      value: fromApiTravel(record),
    };
  }
}
